"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PieChart16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8C14 8.92704 13.7906 9.80397 13.4156 10.5872L10 7.17157V2.34141C12.3304 3.16508 14 5.38756 14 8ZM13.6569 13.6569C14.1323 13.1814 14.5482 12.6464 14.8924 12.0639C15.5961 10.8729 16 9.48362 16 8C16 4.27232 13.4505 1.14012 10 0.252035C9.36076 0.087506 8.6906 0 8 0V2V8L12.2426 12.2426L13.6569 13.6569ZM1 8.00001C1 4.82899 3.10851 2.15044 6 1.28989V3.41605C4.2341 4.18761 3 5.94969 3 8.00001C3 10.7614 5.23858 13 8 13C8.69601 13 9.35881 12.8578 9.96092 12.6008L11.5426 14.0387C10.5034 14.6496 9.29262 15 8 15C4.13401 15 1 11.866 1 8.00001Z", fill: "#383F49" }));
}
function PieChart16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PieChart16Svg, Object.assign({}, svgProps)));
}
exports.default = PieChart16;
//# sourceMappingURL=PieChart16.js.map